'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    AUCTION_HOUSE_ID: 'house_id',
    CAMPAIGN_ID: 'campaignId',
    CATEGORY_ID: 'category_id',
    COUNTRY_CODE_ID: 'country',
    CURRENCY_ID: 'currency',
    CURRENT_BID_ID: 'current_bid',
    DISTANCE_ID: 'distance',
    ESTIMATED_PRICE_ID: 'estimated_price',
    HAMMER_PRICE_ID: 'hammer_price',
    KEYWORD: 'keyword',
    PAGE: 'page',
    PAGE_SIZE: 'pageSize',
    PAGE_SIZE_LEGACY_SUPPORT: 'pagesize',
    SORT: 'sort',
    STATUS: 'status'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/search/paramTypes.js
// module id = jQDs
// module chunks = 57